import { Alert } from "@mui/material";
import { type FC, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { FileUpload, type FileUploadProps } from "../../../../../assets/file-upload";
import { InsertImageButton } from "./insert-image-button";
import { InsertAsLinkButton } from "./insert-link-button";

export const UploadFileEditorModal: FC<FileUploadProps & { type: "pdf" | "image" | "video" }> = ({
  type,
  ...props
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <FileUpload
      {...props}
      allowedFileTypes={type === "pdf" ? ["pdf"] : type === "image" ? ["image"] : ["video"]}
      helperText={t(
        `This ${type === "image" ? "image" : "file"} will be saved in your Content Library under the category “Uploaded Files”`,
      )}
      renderActions={({ handleSave, asset: uploadedAsset }) => {
        const asset = uploadedAsset
          ? {
              ...uploadedAsset,
              content_type: "Uploaded File",
              mime_type: uploadedAsset?.mime_type ?? null,
              project_id: null,
              page_id: null,
            }
          : null;

        return (
          <>
            <InsertAsLinkButton
              asset={asset}
              onClose={props.onClose}
              onInsert={handleSave}
              loading={loading}
              setLoading={setLoading}
            />
            {type === "image" && (
              <InsertImageButton
                buttonText="Insert image"
                asset={asset}
                onClose={props.onClose}
                onInsert={handleSave}
                loading={loading}
                setLoading={setLoading}
              />
            )}
          </>
        );
      }}
      onSuccess={(fileTitle) => {
        toast.custom(
          <Alert severity="success" sx={{ alignItems: "center", "& .MuiAlert-action": { pt: 0 } }}>
            {t(`"${fileTitle}" successfully uploaded to content library`)}
          </Alert>,
        );
      }}
    />
  );
};
